<template>
  <div class="service-page">

    <div class="service-modal" v-if="isShow" @touchmove.prevent>
      <div class="feed-back">
        <img class="close" src="../assets/images/close.png" @click="closeModal">
        <p>数据项反馈</p>
        <div class="form-area">
          <div class="title">问题描述</div>
          <textarea v-model="feedback"></textarea>
          <div class="submit" v-if="feedback!=''" @click="submit">提交</div>
          <div class="submit disabled" v-if="feedback==''">提交</div>
        </div>
      </div>
    </div>

    <div class="main-wrapper">

      <mt-header fixed title="服务列表" style="background:#3189FF;color:#ffffff;">
        <router-link to="/" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
      </mt-header>

      <div class="scroll-wrapper">
        <div class="scroll-content">
          <ul class="service-list">
            <li class="service" v-for="item in goods" :key="item.gid" @click="goPrimaryService(item.gid)">
              <div>
                <span class="title">{{item.description}}</span>
                <span class="price">￥{{item.display_price}}</span>
              </div>
              <div class="service-text">
                <img :src="item.thumb">
                <div class="scenario">
                  {{item.scenario}}
                </div>
              </div>
              <div><span class="detail">查看详情&nbsp;></span></div>
            </li>
          </ul>
        </div>
      </div>
      
      

      <div class="footer">
          <span class="text">还想恢复其他数据？请点击</span>
          <span class="btn" @click="openModal">
            <img src="../assets/images/orderlist_feedback@3x.png">
            告诉我
          </span>
      </div>
    </div>

  </div>
</template>

<script>
import {Popup} from 'mint-ui';
export default {
    name:"purchase",//购买服务
     metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            index: 1,
            goods: [],
            modules:[],
            popupVisible:false,
            mIndex:0,//选中的index
            mid:"",//选中的id
            questions:[],
            des:{},//描述对象,
            isShow: false,
            feedback: ''
        }
    },
    methods:{
      getGoods(){
        var info = {
            api_version : window.config.api_version,
            app_id: window.config.appid
        }
        this.$store.dispatch("getHomeGoods",info).then((res)=>{
          let result = res.data
          if(result.code == 0){
            this.goods = res.data.res.items[this.index].goods
          }
        })
      },
      submit(){
        let access_token = localStorage.access_token
        let data = {
          info: {
            type: 2,
            content: this.feedback,
            app_id: window.config.appid,
            tags: '10'
          },
          access_token: access_token
        }
        this.$store.dispatch('feedback',data).then((res)=>{
          let result = res.data
          if(result.code == 0){
            this.closeModal()
            this.$router.push({name:'suggestion_next',query:{feedback_id: result.res.feedback_id,nextPath:'service'}})
          }
        })
      },
      closeModal(){
        this.isShow = false
      },
      openModal(){
        if(this.validToken('service','告诉我按钮')){
          this.isShow = true
        }
      },
      getGoodsDetail(gid,cb){
        var info = {
            api_version : window.config.api_version,
            gid: gid
        }
        this.$store.dispatch("getGoodsInfo",info).then((res)=>{
          let result = res.data
          if(result.code == 0){
            let goods = res.data.res.data.goods
            this.sa_m_good_selected(goods.description,goods.category,window.location.href)
            let service_type = res.data.res.data.ui_version
            cb(service_type)
          }
        })
      },
      goPrimaryService(gid){
        let that = this
        this.getGoodsDetail(gid,function(data){
          if(data=='v1'){
            that.$router.push({name:"purchase_service",query:{gid:gid}})
          }else if(data=='v2') {
            that.$router.push({name:"primary",query:{gid:gid}})
          }
        })
      }       
    },
    created(){
        this.index = this.$route.query.index
        this.getGoods()
    },
    mounted(){
      
    },
    components:{
        Popup
    }

}
</script>

<style lang="scss" scoped="" type="text/css">
.combo_select{
  padding: 0.3rem 0.66667rem 0.3rem;
  border-bottom: 1px solid #e5e5e5;
}
  .combo_select h3{
    line-height: 1rem;
    font-size: 0.36rem;
  }

  .combo_select div {
    width: 100%;
    height: 1.1rem;
    line-height: 1.1rem;
    border: 1px solid #ccc;
    background: transparent;
    font-size: .48rem;
    color: #989898;
    border-radius: .10667rem;
    margin-bottom: .3rem;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    justify-content: space-around;
  }

  .combo_select .selected{
    background: #3189ff;
    border: 1px solid #3189ff;
    color: #fff;
  }

  .combo_select .selected .select_img{
    display: inline-block;
  }

  .combo_select .selected .no_select_img{
    display: none;
  }

  .combo_select div .select_img {
    display: none;
    width: 0.6rem;
  }

  .combo_select div .no_select_img {
    width: 0.6rem;
  }
  .combo_select div span {
    font-size: 0.36rem;
  }
  .purchase_btn_ser{
    height: 1.17333rem!important;
  }
  .purchase_btn_ser .fee{
    color: #717070;
    font-size: .37333rem;
    display: block;
    -ms-flex: 1;
    flex: 1;
    height: 1rem;
    line-height: 1rem;
    margin-left: .53333rem;
  }
  .purchase_btn_ser .fee .money{
    font-size: .4rem;
    color: #ff001f;
  }
  .purchase_btn_ser button{
    background: #3189ff;
    border: none;
    color: #fff;
    width: 4.26667rem;
    font-size: .48rem;
    height: 1.17333rem;
    cursor: pointer;
  }
  .module_description{
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/Service.vue